import { create } from 'zustand';

const useSpectraDetailsModalStore = create((set) => ({
  isOpen: false,
  spaceToShow: null,
  callback: null,

  setIsOpen: (isOpen, spaceToShow = null, callback = null) =>
    set({ isOpen, spaceToShow, callback }),
}));

export default useSpectraDetailsModalStore;
